export default [{
  path: '/home',
  component: resolve => require(['@/components/base/view/main/main.vue'], resolve),
  children: [{
    path: '/comment/audit',
    component: resolve => require(['@/components/base/view/interact/comment/audit.vue'], resolve) //评论审核
  }, {
    path: '/vote',
    component: resolve => require(['@/components/base/view/interact/vote/list/list.vue'], resolve) //投票管理
  }, {
    path: '/vote/edit/:id',
    component: resolve => require(['@/components/base/view/interact/vote/edit/edit.vue'], resolve) //投票列表
  }, {
    path: '/vote/info/:id',
    component: resolve => require(['@/components/base/view/interact/vote/info/info.vue'], resolve) //投票详情
  }, {
    path: '/suggest/edit',
    component: resolve => require(['@/components/base/view/interact/suggest/edit/edit.vue'], resolve) //填写建议反馈
  }]
}, {
  path: '/vote/join/:id',
  component: resolve => require(['@/components/base/view/interact/vote/join/join.vue'], resolve) //参与投票界面
}]



// WEBPACK FOOTER //
// ./src/components/base/router/interact.js